var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isAllowed),expression:"isAllowed"}],staticClass:"btn btn-primary--inverse",on:{"click":_vm.openModal}},[_c('img',{staticClass:"mr-2",attrs:{"src":require("@/assets/img/icons/cancel.svg")}}),_c('span',[_vm._v(_vm._s(_vm.buttonName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }